module.exports = __webpack_public_path__ + "img/prize_3.117aee4f.gif";